<script setup>
import { computed } from 'vue';
import LetPage from '@/letapps-vue/components/LetPage';
import { useRoute } from 'vue-router';
import LinkDetail from '@/pages/links/LinksDetail.vue';

const route = useRoute();
const linkId = computed(() => Number(route.params.id));
</script>

<template>
  <LetPage fit>
    <LinkDetail :linkId="linkId" />
  </LetPage>
</template>

<style scoped lang="scss"></style>
